<template>
    <div>
        <b-card title="Filtros">
            <div class="card-text">
                <b-row>
                    <b-col align-h="center" cols="12" md="3">
                        <app-form-select-input
                            placeholder="Tipo de servicio"
                            :options="serviceTypes"
                            v-model="filters.type"
                        />
                    </b-col>
                    <b-col align-h="center" cols="12" md="3">
                        <app-form-text-input
                            placeholder="Placa / Documento"
                            v-model="filters.document"
                        />
                    </b-col>
                    <b-col cols="12" md="3">
                        <app-form-select-input
                            v-model="filters.user"
                            :options="bodyGuards"
                            :disabled="!bodyGuards.length"
                            placeholder="Escolta"
                        ></app-form-select-input>
                    </b-col>
                    <b-col cols="12" md="3" v-if="showClient">
                        <app-form-text-input
                            placeholder="Nombre del cliente"
                            v-model="filters.name_client"
                        />
                    </b-col>
                    <b-col cols="12" md="3">
                        <app-date-picker
                            v-model="filters.startDate"
                            placeholder="Desde"
                        ></app-date-picker>
                    </b-col>
                    <b-col cols="12" md="3">
                        <app-date-picker
                            v-model="filters.endDate"
                            placeholder="Hasta"
                        ></app-date-picker>
                    </b-col>
                    <b-col cols="12" md="6" class="right-spaced">
                        <b-button
                            variant="primary"
                            class="btn-xs-block"
                            @click="$emit('filter', filters)"
                            ><i class="fa fa-filter"></i
                        ></b-button>
                        <b-button
                            variant="success"
                            class="btn-xs-block"
                            @click="exportData"
                            ><i class="fa fa-download"></i
                        ></b-button>
                        <b-button
                            variant="secondary"
                            class="btn-xs-block"
                            @click="clearFilters"
                            ><i class="fa fa-times-circle"></i
                        ></b-button>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>
<script>
import usersRepository from '../../../../../repositories/users.repository'
export default {
    props: {
        showClient: {
            type: Boolean,
            default: () => true,
        },
        export: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            filters: {
                type: '',
                document: '',
                name_client: '',
                startDate: '',
                endDate: '',
                user: '',
            },
            serviceTypes: [
                {
                    name: 'Vehicular',
                    id: 'vehicular',
                },
                {
                    name: 'Personal',
                    id: 'personal',
                },
            ],
            bodyGuards: [],
        }
    },
    methods: {
        clearFilters() {
            // this.selectClient= '';
            // this.selectSupervisor = '';
            Object.keys(this.filters).map((key) => (this.filters[key] = ''))
            this.$emit('filter', null)
        },
        exportData() {
            const params = []

            const filters = !!this.user.profile.client_side
                ? { ...this.filters, clientId: this.client.id }
                : { ...this.filters }

            Object.keys(filters).map(
                (key) => !!filters[key] && params.push(`${key}=${filters[key]}`)
            )
            const queryString = params.join('&')
            const url = `exports/bodyguard-services/export-excel?${queryString}`
            window.open(url, '_blank')
        },
        async loadBodyGuards() {
            const ur = { ...usersRepository }
            const { data } = await ur.getBodyGuards()
            this.bodyGuards = data
        },
    },
    created() {
        this.loadBodyGuards()
    },
}
</script>
